import {useEffect} from "react";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";

const useApp = () => {
    const {BASE_URL, SP_NAME} = STRATEGIC_PARTNER.S3;

    useEffect(() => {
        const setupFaviconLink = (rel) => {
            let link = document.querySelector(`link[rel~=${rel}]`);
            if (!link) {
                link = document.createElement('link');
                link.rel = rel;
                link.href = `${BASE_URL}/${SP_NAME}/common/favicon.png`;
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        }

        setupFaviconLink('icon');
        setupFaviconLink('apple-touch-icon');
    }, [BASE_URL, SP_NAME]);
}

export default useApp;